module.exports = __webpack_public_path__ + "media/V114.d8f36c1d.mp4";